<template>
  <div v-if="isLoaded" class="text-black safe-refill">
    <div
      v-if="promotion.display"
      class="p-4 bg-blue-500 bg-cover bg-center mb-4"
      :style="
        'background-image:url(/assets/imgs/background/' +
        promotion.i18n.bg_img +
        ')'
      "
    >
      <div class="bg-white bg-opacity-75 p-4 text-center whitespace-pre-line">
        <h2 class="text-xl font-bold">{{ promotion.i18n.title }}</h2>
        {{ promotion.i18n.description }}
      </div>
    </div>
    <div v-else class="p-4 text-center">
      <h2 class="text-xl font-bold">{{ i18n.new }}</h2>
    </div>
    <p class="text-center">
      {{ i18n.title }}
    </p>
    <custom-amount :bonuses="bonuses" :promotion="promotion" />
    <promotion-table
      v-if="promotion.status"
      :i18n="i18n"
      :bonuses="bonuses"
      :promotion="promotion"
    />
    <div v-else class="pt-3">
      <div
        class="flex items-center bg-action- pb-1 text-center font-bold text-sm"
      >
        <div class="w-1/3">{{ i18n.cost_amount }}</div>
        <div class="w-1/3">{{ i18n.bonus }}</div>
        <div class="w-1/3 pr-4">{{ i18n.render_amount }}</div>
      </div>
      <router-link
        v-for="(line, index) in bonuses"
        :key="line.cost_amount_html"
        class="group cursor-pointer flex py-2 text-center items-center hover:bg-select"
        :class="index % 2 ? 'bg-white' : 'bg-full-white'"
        :to="{ name: 'invoice.new', query: { credits: line.credit } }"
      >
        <div class="w-1/3" v-html="line.cost_amount_html"></div>
        <div class="text-center flex justify-around w-1/3">
          <div
            class="text-white p-2 w-20 rounded font-bold text-sm"
            :class="'data-level-' + line.level"
            v-html="line.discount_html"
          ></div>
        </div>
        <div class="w-1/3">
          <span v-html="line.render_amount_html"></span>
          <span class="w-4 pl-4 inline-block">
            <div
              class="group-hover:inline hidden bg-action px-3 py-2 rounded text-white"
            >
              <font-awesome-icon icon="arrow-right"></font-awesome-icon>
            </div>
          </span>
        </div>
      </router-link>
    </div>
    <div v-if="promotion.display">
      <p class="py-5 text-xs text-gray-800" v-text="promotion.i18n.fineprint" />
    </div>
  </div>
</template>

<script>
import useSWRV from "@/store/swrv";
import { computed } from "@vue/composition-api";

import CustomAmount from "./CustomAmount";
import PromotionTable from "./PromotionTable";

export default {
  setup() {
    const { data, error, isLoading, reload, isLoaded } = useSWRV(
      "/api/app/bonuses"
    );
    const i18n = computed(() => data.value.data.i18n);
    const promotion = computed(() => data.value.data.promotion);
    const bonuses = computed(() => data.value.data.data_refill);
    return {
      rawdata: data,
      i18n,
      promotion,
      bonuses,
      error,
      isLoading,
      reload,
      isLoaded,
    };
  },
  components: {
    CustomAmount,
    PromotionTable,
  },
};
</script>
